import { render } from "./Sr.vue?vue&type=template&id=a8d786be"
import script from "./Sr.vue?vue&type=script&lang=js"
export * from "./Sr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__